<!--
 * @Author: Tang Hao
 * @Date: 2025-12-22 14:00:17
 * @LastEditors: Tang Hao
 * @LastEditTime: 2025-12-22 15:36:04
 * @Description:
-->
<template>
  <div>
    对账时间区间选择不能超过3个月
  </div>
</template>

<script>

export default {
  name: 'Payment',
  props: {
    value: [Number, String],
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value() {
      this.num = this.value;
    },
  },
  data() {
    return {
      num: '',
    };
  },

  methods: {
    handleChange(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<style lang="less" scoped></style>
